import { useEffect } from "react";
import { getNow } from '../utils/shared/time';

export default function useClock(setCurrentTime){
    useEffect(() => {
        let timeoutId;

        const updateClock = () => {
            const now = getNow();
            const delay = 60000 - (now.millisecond() + now.second() * 1000);
            timeoutId = setTimeout(updateClock, delay);
            setCurrentTime(now);
        };
        updateClock();

        return () => clearTimeout(timeoutId);
    }, []);
}